import React from "react";
import { ChevronLeft } from "lucide-react";

interface AdBuilderHeaderProps {
  campaignName: string;
  adCategoryName: string;
  adTypeName: string;
  publisherName: string;
  onBack: () => void;
}

const AdBuilderHeader: React.FC<AdBuilderHeaderProps> = ({
  campaignName,
  adCategoryName,
  adTypeName,
  publisherName,
  onBack,
}) => {
  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <button
            onClick={onBack}
            className="text-pink-500 hover:text-pink-600 transition-colors"
          >
            <ChevronLeft size={24} />
          </button>
          <h1 className="text-2xl">
            <span className="font-semibold text-gray-900">{campaignName}</span>{" "}
            / {adCategoryName}
          </h1>
        </div>
      </div>

      <div className="flex items-center justify-between">
        <div className="flex-1">
          <div className="text-sm text-gray-600 mb-1">Ad Type</div>
          <div className="text-xl font-semibold text-gray-900">{adTypeName}</div>
        </div>
        <div className="text-right">
          <div className="text-sm text-gray-600 mb-1">Publisher</div>
          <div className="text-xl font-semibold text-gray-900">
            {publisherName}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdBuilderHeader;
